/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".scroll-title[_ngcontent-%COMP%]{\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  width: 4rem;\n  height: 0.5rem;\n  font-size: 0.25rem;\n  color: white;\n  line-height: 0.5rem;\n  text-align: center;\n  border-radius: 1rem;\n  background-color: rgba(0,0,0,0.5);\n  -webkit-transform: translate(-50%,-50%);\n          transform: translate(-50%,-50%);\n  z-index: 10005;\n}\n\n.scroll-title[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{\n  margin-right: 0.2rem;\n}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/scroll-title/component.scroll-title.css.shim.ngstyle.js.pre-build-optimizer.js